<template>
  <div>
    <b-breadcrumb :items="breadcrumb"/>
    <h1>Jury Assignments</h1>
    <h2>Assign New Jury</h2>
    <div class="row">
      <div class="col-md-10">
        <p>Use this to automatically assign completed SV applications to Team Leaders.
          Once assignments are made, Team Leaders will be able to review applications
          assigned to them.</p>
          <p><strong>Do not use this if you do not want to lose existing assignment and scoring data.</strong></p>
        <b-form inline>
          <b-form-group label="Team Leaders Per SV App" :description="assignmentsPerTL">
            <b-input type="number" v-model="TLsPerSVApp" id="apps-per-tl"/>
            <b-button v-b-modal.assignModal :disabled="isAssigning" variant="primary">Assign</b-button>
            <div v-if="isAssigning" class="loader">Assigning...</div>
          </b-form-group>
        </b-form>
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal ref="assignModal" id="assignModal" title="Assign Jury" @ok="assignJury">
      <p>This process takes several minutes.</p>
      <p class="my-4"><strong>Warning</strong>: This will reset assignments and any scoring data will be lost.</p>
    </b-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'JuryAssignments',
    data () {
      return {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'Home' }
          },
          {
            text: 'Jury Assignments',
            to: { name: 'JuryAssignments' }
          }
        ],
        TLsPerSVApp: 3,
        TLs: 22,
        isAssigning: false
      }
    },
    computed: {
      assignmentsPerTL () {
        if (this.appStatistics.completed !== 0) {
          let appsPerTL = ((this.appStatistics.completed - this.TLs) * this.TLsPerSVApp) / this.TLs
          return 'This will assign ' + Math.floor(appsPerTL) + ' apps per TL.'
        } else {
          return ''
        }
      },
      ...mapState('admin', ['appStatistics'])
    },
    methods: {
      assignJury () {
        this.isAssigning = true
        this.$store.dispatch('admin/assignSVAppsToTLs', this.TLsPerSVApp).then(() => {
          this.isAssigning = false
        }).catch(err => {
          this.isAssigning = false
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/JuryAssignments.vue